<template>
  <b-card>
    <div class="mb-2">
      <h4 class="text-2xl text-black ">
        <strong>Conversation History</strong>
      </h4>
    </div>

    <b-row
      v-show="isLoadingCard"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
    >
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
    </b-row>
    <div
      v-show="!isLoadingCard"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
    >
      <b-card
        v-for="(item, index) in dataCard"
        :key="index"
        class="border !p-0"
      >
        <div class="grid gap-8">
          <div class="flex justify-between items-center font-semibold text-base leading-relaxed tracking-wide align-middle">
            <span class="!capitalize">{{ defineTitleCard(item.info) }}</span>
            <!-- <span class="text-[#F95031]">{{ item.total_message_sent }}</span> -->
          </div>
          <div class="flex items-center gap-1">
            <span class="text-[#333333] text-2xl font-semibold">{{ item.total }}</span>
          </div>
        </div>
      </b-card>
    </div>
    <div>
      <BOverlay
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        rounded="sm"
      >
        <BTable
          id="scroll"
          ref="scroll"
          :items="items"
          :fields="fieldsDetailBroadcastLiteTable"
          show-empty
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          sticky-header="500px"
          class="mt-1"
          @scroll.native="handleScroll"
        >
          <!-- <template #cell(sended_at)="data">
            <div class="text-center text-sm text-[#666666]">
              {{ data.item.updated_at }}
            </div>
          </template> -->
          <template #cell(status)="data">
            <div>
              <div
                :class="data.item.status === 'FAILED' ? 'text-red-500' : data.item.status === 'SUCCESS' ? 'text-green-500' : 'text-capitalize  font-[500]'"
              >
                {{ capitalizeWords(data.item.status) }}
              </div>

            </div>
          </template>
          <template #cell(template_type)="data">
            <span>{{ defineBroadcastType(data.item.template_type) }}</span>
          </template>
          <template #cell(contact)="data">
            <div class="text-black">
              {{ data.item.receiver_phone_number }}
            </div>
            <div class="text-sm">
              {{ data.item.receiver_name }}
            </div>
          </template>
        </BTable>
      </BOverlay>
    </div>
  </b-card>
</template>
<script>
import { IDRWithoutLbl } from '@/libs/currency'
import { DAY_MONTH_YEAR } from '@/libs/formatDate'
import { apiGetDetailBroadcastHistoryLite, apiGetDetailBroadcastInfoLite } from './Broadcast/service/api.broadcast.service'
import { fieldsDetailBroadcastLiteTable, capitalizeWords } from './Broadcast/config'

export default {
  data() {
    return {
      isLoading: false,
      isLoadingCard: false,
      limit: 15,
      cursor: '',
      lastData: false,
      dataCard: [],
      items: [],
      fieldsDetailBroadcastLiteTable,
      DAY_MONTH_YEAR,
      IDRWithoutLbl,
      capitalizeWords,
      idBroadcast: this.$route.params.id,
    }
  },
  mounted() {
    this.getInfoBroadcst()
    this.fetchHistoryBroadcast(true)
  },
  methods: {
    capitalizer(str) {
      return str
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase())
    },
    defineTitleCard(title) {
      const type = {
        total_receiver: 'Total Penerima',
        total_success: 'Success',
        total_failed: 'Failed',
      }
      return type[title]
    },
    defineBroadcastType(type) {
      const broadcast = {
        TEXT: 'Pesan Teks',
        MEDIA: 'Pesan Media',
        TEXT_MEDIA: 'Pesan Teks & Media',
      }
      return broadcast[type]
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.fetchHistoryBroadcast(false)
      }
    },
    async fetchHistoryBroadcast(reset = false) {
      // Skip if we're loading next page but already at the end
      if (!reset && this.lastData) {
        return
      }

      this.isLoading = true

      // Reset cursor when fetching initial data
      if (reset) {
        this.cursor = ''
      }

      try {
        const response = await apiGetDetailBroadcastHistoryLite(this.idBroadcast, this.cursor, this.limit)
        const items = response.data.data || []

        // Replace or append items based on reset flag
        if (reset) {
          this.items = items
        } else {
          this.items.push(...items)
        }

        // Update cursor and lastData flag
        this.cursor = response.data.meta?.pagination?.next_cursor_str || ''
        this.lastData = items.length < this.limit || !this.cursor

        this.isLoading = false
      } catch (error) {
        console.error(error)
        this.isLoading = false
        this.$toast_error({ message: 'Gagal mengambil data history broadcast' })
      }
    },
    async getInfoBroadcst() {
      try {
        this.isLoadingCard = true
        const { data } = await apiGetDetailBroadcastInfoLite(this.idBroadcast)
        this.dataCard = data.data
      } catch {
        this.$toast_error({
          message: 'Gagal mengambil data info broadcast',
        })
      } finally {
        this.isLoadingCard = false
      }
    },
  },
}
</script>
